import { ProductTaxRuleDto } from '@tiendanube/common';
import { SelectedProductInterface } from 'domains/Catalog/Products/components';

export const formatToSelectedProduct = (
  product: ProductTaxRuleDto,
): SelectedProductInterface => ({
  id: product?.product_id,
  name: product?.product_name,
  imageUrl: product?.product_image_url,
  stock: false,
  visible: true,
  attributes: [],
  variants: [],
});

export const unFormatToSelectedProduct = (
  product: SelectedProductInterface,
): ProductTaxRuleDto => ({
  product_id: product.id,
  product_name: product.name,
  product_image_url: product.imageUrl,
});

export const initialValues = {
  description: '',
  iva_rate: null,
  is_general: false,
  products: [] as ProductTaxRuleDto[],
};
